import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { FuseCardComponent } from '@fuse/components/card';

@Component({
  selector: 'articles-type01',
  standalone: true,
  imports: [MatIconModule, HeadingSectionType01Component,FuseCardComponent],
  templateUrl: './articles-type01.component.html',
  styleUrl: './articles-type01.component.scss'
})
export class ArticlesType01Component {

  public view: any = {
    title: ''
  }

  constructor(public _tfmService: TFMService, private route: ActivatedRoute,) {

    //   route.paramMap.subscribe(res => {
    //     //this.view.destination = this.route.snapshot.params['destination'];
    //     this.view.type = this.route.snapshot.data['type'];
    //     this.view.isPromo = this.route.snapshot.data['isPromo'];

    //     this.view.id = res.get("id");
    //   });

    //   this._tfmService.getSite().subscribe(res => {
    //     this.site = res;

    //     if (this.view.type != "list"){
    //       //Set title
    //       this.title.setTitle(this.site.name + " - " + this.site.slogan);
    //     }

    //     this._tfmservice.getSiteLayoutOptions().subscribe(options => {
    //       this.site.layoutOptions = options;
    //     });
    //   });
    // }
  }
  ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);

      });
    this._tfmService.getArticles().then(res => {
            this.view.articles = res;
            this._tfmService.log(this.view.articles)


      });
    }
}
